<script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import { useMapAdStore } from "@/stores/MapAdStore";

  const props = defineProps({
    adSlot: {
      type: String,
      required: true
    }
  })

  const mapAdStore = useMapAdStore();

  const webMapRectangleAd = ref(null);

  onMounted(() => {
    mapAdStore.initAd(props.adSlot);
  });

  onUnmounted(() => {
    mapAdStore.removeAdSlot(props.adSlot);
  }); 
</script>

<template>
  <div 
    class="jwx-map-ad"
    data-map="ads">
      <div 
        :id="props.adSlot"
        style="min-width: 300px; min-height: 250px;"
        ref="webMapRectangleAd"
      >
    </div>
  </div>
</template>